var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-1"},[_c('vue-skeleton-loader',{attrs:{"width":120,"height":15}}),_c('vue-skeleton-loader',{staticClass:"mt-1",attrs:{"width":220,"height":12}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }